var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Vue, Component, Watch, Mixins, } from 'vue-property-decorator';
import * as parse from 'date-fns/parse';
import * as format from 'date-fns/format';
import { TableHeading } from '@/typings';
import { VacationService } from '@/services/vacation-service';
import { AuthService } from '@/services/auth-service';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import TableButtonEdit from '@/components/shared/TableButton_Edit.vue';
import TableButtonDelete from '@/components/shared/TableButton_Delete.vue';
import TableButtonRestore from '@/components/shared/TableButton_Restore.vue';
import TableButtonView from '@/components/shared/TableButton_View.vue';
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
import DeletePromptDialog from '@/components/shared/DeletePromptDialog.vue';
import PromptDialog from '@/components/shared/PromptDialog.vue';
import LayoutMixin from '@/mixins/layout-mixin';
import SnackbarMixin from '@/mixins/snackbar-mixin';
var VacationManagement = /** @class */ (function (_super) {
    __extends(VacationManagement, _super);
    function VacationManagement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.items = [];
        _this.showStatuses = ['A', 'P'];
        _this.searchVisible = false;
        _this.searchTerm = '';
        _this.loading = false;
        _this.saving = false;
        _this.filterSideSheet = false;
        _this.addEditSideSheet = false;
        _this.deleteDialog = false;
        _this.restoreDialog = false;
        _this.validationRules = {};
        _this.options = {
            userIds: [],
            fromHours: [],
            toHours: [],
            statuses: [],
        };
        _this.fromDatePicker = false;
        _this.fromTimePicker = false;
        _this.toDatePicker = false;
        _this.toTimePicker = false;
        _this.selectedItem = {};
        _this.isExisting = false;
        _this.readonly = false;
        _this.headers = [
            new TableHeading('User', 'userID'),
            new TableHeading('From', 'startDate'),
            new TableHeading('To', 'endDate'),
            new TableHeading('Type', 'backupType'),
            new TableHeading('Status', 'status'),
            new TableHeading('Modified By', 'modifiedByUserID'),
            new TableHeading('Modified On', 'modifiedDate'),
            new TableHeading('Actions', 'user', false),
        ];
        _this.pagination = {
            descending: false,
            page: 1,
            rowsPerPage: 10,
            sortBy: 'userID',
            totalItems: 0,
        };
        return _this;
    }
    Object.defineProperty(VacationManagement.prototype, "footerOptions", {
        get: function () {
            return {
                itemsPerPageOptions: [5, 10, 20, 50, 100],
            };
        },
        enumerable: false,
        configurable: true
    });
    VacationManagement.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // initialize
                this.selectedItem = this.vacationService.getDefault();
                this.validationRules = this.vacationService.getValidationRules();
                this.readonly = this.vacationService.canEditVacations === false;
                return [2 /*return*/];
            });
        });
    };
    VacationManagement.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, 4, 5]);
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, this.vacationService.all(true)];
                    case 1:
                        _a.items = _b.sent();
                        return [4 /*yield*/, this.loadInitialReferenceData()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        console.error(error_1);
                        this.showSnackbar({
                            text: 'Unable to retrieve vacations',
                            color: 'error',
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    VacationManagement.prototype.openDeleteDialog = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    this.setSelectedItem(item);
                    this.deleteDialog = true;
                }
                catch (error) {
                    console.error(error);
                    this.deleteDialog = false;
                    this.showSnackbar({ text: 'Unable to delete vacation', color: 'error' });
                }
                return [2 /*return*/];
            });
        });
    };
    VacationManagement.prototype.deleteVacation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        data = __assign({}, this.selectedItem);
                        return [4 /*yield*/, this.vacationService.delete(data)];
                    case 1:
                        response = _a.sent();
                        // show error if returned
                        if (response.success === false) {
                            this.showSnackbar({
                                text: response.message,
                                color: 'error',
                            });
                            return [2 /*return*/];
                        }
                        // update or add the vacation record
                        this.updateVacation(response.data);
                        this.showSnackbar({
                            // tslint:disable-next-line:max-line-length
                            text: "Successfully deleted vacation for '" + this.selectedItem.userID + "'",
                            color: 'success',
                        });
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        console.error(error_2);
                        this.showSnackbar({ text: 'Unable to delete vacation', color: 'error' });
                        return [3 /*break*/, 4];
                    case 3:
                        this.deleteDialog = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VacationManagement.prototype.openRestoreDialog = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    this.setSelectedItem(item);
                    this.restoreDialog = true;
                }
                catch (error) {
                    console.error(error);
                    this.restoreDialog = false;
                    this.showSnackbar({ text: 'Unable to restore vacation', color: 'error' });
                }
                return [2 /*return*/];
            });
        });
    };
    VacationManagement.prototype.restoreVacation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        data = __assign({}, this.selectedItem);
                        return [4 /*yield*/, this.vacationService.restore(data)];
                    case 1:
                        response = _a.sent();
                        // show error if returned
                        if (response.success === false) {
                            this.showSnackbar({
                                text: response.message,
                                color: 'error',
                            });
                            return [2 /*return*/];
                        }
                        // update or add the vacation record
                        this.updateVacation(response.data);
                        this.showSnackbar({
                            // tslint:disable-next-line:max-line-length
                            text: "Successfully restored vacation for '" + this.selectedItem.userID + "'",
                            color: 'success',
                        });
                        return [3 /*break*/, 4];
                    case 2:
                        error_3 = _a.sent();
                        console.error(error_3);
                        this.showSnackbar({ text: 'Unable to restore vacation', color: 'error' });
                        return [3 /*break*/, 4];
                    case 3:
                        this.restoreDialog = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VacationManagement.prototype.setVacationToStart = function () {
        // add 'NOW' to be the first item in the collection
        this.selectedItem.fromDate = format(new Date(), 'YYYY-MM-DD');
        this.options.fromHours.unshift('NOW');
        this.selectedItem.fromTime = 'NOW';
    };
    VacationManagement.prototype.endVacation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        data = __assign({}, this.selectedItem);
                        return [4 /*yield*/, this.vacationService.end(data)];
                    case 1:
                        response = _a.sent();
                        if (response.success === false) {
                            this.showSnackbar({
                                text: response.message,
                                color: 'error',
                            });
                            return [2 /*return*/];
                        }
                        // update or add the vacation record
                        this.updateVacation(response.data);
                        this.showSnackbar({
                            // tslint:disable-next-line:max-line-length
                            text: "Successfully set vacation for '" + this.selectedItem.userID + "' to end at the start of the next hour",
                            color: 'success',
                        });
                        this.addEditSideSheet = false;
                        return [3 /*break*/, 4];
                    case 2:
                        error_4 = _a.sent();
                        console.error(error_4);
                        this.showSnackbar({
                            text: "Unable to end vacation for '" + this.selectedItem.userID + "'",
                            color: 'error',
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        this.saving = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VacationManagement.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var validationResult, data, response, error_5;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        return [4 /*yield*/, this.$validator.validate('vacation.*')];
                    case 1:
                        validationResult = _a.sent();
                        // return if there are validation errors
                        if (validationResult === false) {
                            return [2 /*return*/];
                        }
                        this.saving = true;
                        data = __assign({}, this.selectedItem);
                        return [4 /*yield*/, this.vacationService.save(data)];
                    case 2:
                        response = _a.sent();
                        // save failed, show message and return
                        if (response.success === false) {
                            this.showSnackbar({
                                // tslint:disable-next-line:max-line-length
                                text: response.message,
                                color: 'error',
                            });
                            return [2 /*return*/];
                        }
                        // update or add the vacation record
                        this.updateVacation(response.data);
                        if (data.fromTime === 'NOW') {
                            this.showSnackbar({
                                text: "Successfully saved vacation for '" + this.selectedItem.userID + "'. Page will refresh in 10 seconds.",
                                color: 'success',
                            });
                            // reload after 10 seconds
                            setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            this.loading = true;
                                            _a = this;
                                            return [4 /*yield*/, this.vacationService.all(true)];
                                        case 1:
                                            _a.items = _b.sent();
                                            this.loading = false;
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, 10000);
                        }
                        else {
                            this.showSnackbar({
                                text: "Successfully saved vacation for '" + this.selectedItem.userID + "'",
                                color: 'success',
                            });
                        }
                        this.addEditSideSheet = false;
                        return [3 /*break*/, 5];
                    case 3:
                        error_5 = _a.sent();
                        console.error(error_5);
                        this.showSnackbar({
                            text: "Unable to save vacation for '" + this.selectedItem.userID + "'",
                            color: 'error',
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.saving = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Toggle filter side sheet
     */
    VacationManagement.prototype.toggleFilter = function () {
        var _this = this;
        if (this.filterSideSheet === false) {
            this.addEditSideSheet = false;
        }
        this.$nextTick(function () {
            _this.filterSideSheet = true;
        });
    };
    /**
     * Toggle add / edit side sheet
     */
    VacationManagement.prototype.toggleAddEdit = function (item) {
        var _this = this;
        // reset validation
        this.$validator.reset();
        if (item) {
            // reset hours collection
            this.options.fromHours = this.vacationService.getHours();
            this.isExisting = true;
            // set the selected item
            this.setSelectedItem(item);
        }
        else {
            this.isExisting = false;
            this.selectedItem = this.vacationService.getDefault();
        }
        if (this.addEditSideSheet === false) {
            this.filterSideSheet = false;
            this.$nextTick(function () {
                _this.addEditSideSheet = true;
            });
        }
    };
    VacationManagement.prototype.toggleViewOnly = function (item) {
        var _this = this;
        // reset validation
        this.$validator.reset();
        if (item) {
            this.isExisting = true;
            // set the selected item
            this.setSelectedItem(item);
        }
        if (this.addEditSideSheet === false) {
            this.filterSideSheet = false;
            this.$nextTick(function () {
                _this.addEditSideSheet = true;
            });
        }
    };
    VacationManagement.prototype.toggleSearchVisibility = function () {
        var _this = this;
        this.searchVisible = !this.searchVisible;
        if (this.searchVisible === true) {
            this.$nextTick(function () {
                var searchInput = _this.$refs.searchInput;
                searchInput.focus();
            });
        }
    };
    /**
     * Get a friendly text for the status
     * todo: should use variables from vacation service.
     * Requires modifications to dependency injection so not lazy injected
     */
    VacationManagement.prototype.formatFriendlyStatus = function (status) {
        switch (status) {
            case this.activeStatus:
                return 'Active';
            case this.inactiveStatus:
                return 'Deleted';
            case this.plannedStatus:
                return 'Planned';
            case this.completedStatus:
                return 'Completed';
            default:
                return 'N/A';
        }
    };
    Object.defineProperty(VacationManagement.prototype, "filteredItems", {
        get: function () {
            var _this = this;
            this.loading = true;
            var items = __spreadArrays(this.items);
            // filter only logged in users vacations
            items =
                this.showStatuses.length > 0
                    ? items.filter(function (item) { return _this.showStatuses.includes(item.status); })
                    : items;
            this.loading = false;
            return items;
        },
        enumerable: false,
        configurable: true
    });
    VacationManagement.prototype.onShowStatusesChanged = function (value, oldValue) {
        var _this = this;
        if (value && value.length && value.length !== oldValue.length) {
            this.$nextTick(function () {
                _this.pagination.page = 1;
            });
        }
    };
    Object.defineProperty(VacationManagement.prototype, "fromDateObject", {
        get: function () {
            return this.selectedItem.fromDate !== ''
                ? parse(this.selectedItem.fromDate)
                : new Date();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VacationManagement.prototype, "toDateObject", {
        get: function () {
            return this.selectedItem.toDate !== ''
                ? parse(this.selectedItem.toDate)
                : new Date();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VacationManagement.prototype, "fromDateFormatted", {
        get: function () {
            return this.selectedItem.fromDate !== ''
                ? this.formatFriendlyDate(this.selectedItem.fromDate)
                : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VacationManagement.prototype, "toDateFormatted", {
        get: function () {
            return this.selectedItem.toDate !== ''
                ? this.formatFriendlyDate(this.selectedItem.toDate)
                : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VacationManagement.prototype, "nowFormatted", {
        get: function () {
            return format(new Date(), 'YYYY-MM-DD');
        },
        enumerable: false,
        configurable: true
    });
    VacationManagement.prototype.formatFriendlyDate = function (date, includeTime) {
        if (includeTime === void 0) { includeTime = false; }
        return date && includeTime
            ? format(date, 'MM/D/YYYY HH:mm')
            : format(date, 'MM/D/YYYY');
    };
    Object.defineProperty(VacationManagement.prototype, "activeStatus", {
        get: function () {
            return 'A';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VacationManagement.prototype, "inactiveStatus", {
        get: function () {
            return 'I';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VacationManagement.prototype, "plannedStatus", {
        get: function () {
            return 'P';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VacationManagement.prototype, "completedStatus", {
        get: function () {
            return 'C';
        },
        enumerable: false,
        configurable: true
    });
    VacationManagement.prototype.loadInitialReferenceData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, hours;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.options;
                        return [4 /*yield*/, this.vacationService.getVacationUsers()];
                    case 1:
                        _a.userIds = _b.sent();
                        this.options.statuses = this.vacationService.getStatuses();
                        hours = this.vacationService.getHours();
                        this.options.fromHours = __spreadArrays(hours);
                        this.options.toHours = __spreadArrays(hours);
                        return [2 /*return*/];
                }
            });
        });
    };
    VacationManagement.prototype.updateVacation = function (vacation) {
        // take a copy of all the vacations
        var items = __spreadArrays(this.items);
        // update the item with the new values
        var matchingItems = items.filter(function (item) { return item.vacationID.toString() === vacation.vacationID.toString(); });
        if (matchingItems.length > 0) {
            // update the existing item
            var item = matchingItems[0];
            item.vacationID = vacation.vacationID;
            item.userID = vacation.userID;
            item.backupType = vacation.backupType;
            item.notes = vacation.notes;
            item.status = vacation.status;
            item.startDate = vacation.startDate;
            item.endDate = vacation.endDate;
            item.modifiedByUserID = vacation.modifiedByUserID;
            item.modifiedDate = vacation.modifiedDate;
        }
        else {
            // update the ID on the selected item
            this.selectedItem.vacationID = vacation.vacationID;
            // add the new item
            items.push(vacation);
        }
        // update the collection to the new collection
        this.items = items;
    };
    VacationManagement.prototype.setSelectedItem = function (item) {
        // parse the dates
        var fromDate = parse(item.startDate);
        var toDate = parse(item.endDate);
        this.selectedItem = {
            vacationID: item.vacationID,
            userID: item.userID,
            fromDate: format(fromDate, 'YYYY-MM-DD'),
            fromTime: item.status === this.activeStatus
                ? format(fromDate, 'HH:mm') // keep the minutes - used when vacation was immediately started
                : format(fromDate, 'HH:00'),
            toDate: format(toDate, 'YYYY-MM-DD'),
            toTime: format(toDate, 'HH:00'),
            backupType: item.backupType,
            notes: item.notes,
            status: item.status,
            modifiedByUserID: item.modifiedByUserID,
            modifiedDate: item.modifiedDate,
        };
        if (item.status === this.activeStatus) {
            this.options.fromHours.unshift(this.selectedItem.fromTime);
        }
    };
    var _a, _b;
    __decorate([
        lazyInject(TYPES.VacationService),
        __metadata("design:type", typeof (_a = typeof VacationService !== "undefined" && VacationService) === "function" ? _a : Object)
    ], VacationManagement.prototype, "vacationService", void 0);
    __decorate([
        lazyInject(TYPES.AuthService),
        __metadata("design:type", typeof (_b = typeof AuthService !== "undefined" && AuthService) === "function" ? _b : Object)
    ], VacationManagement.prototype, "authService", void 0);
    __decorate([
        Watch('showStatuses', { immediate: false, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Array]),
        __metadata("design:returntype", void 0)
    ], VacationManagement.prototype, "onShowStatusesChanged", null);
    VacationManagement = __decorate([
        Component({
            components: {
                'delete-prompt-dialog': DeletePromptDialog,
                'prompt-dialog': PromptDialog,
                'table-button-edit': TableButtonEdit,
                'table-button-delete': TableButtonDelete,
                'table-button-restore': TableButtonRestore,
                'table-button-view': TableButtonView,
            },
            $_veeValidate: { validator: 'new' },
        })
    ], VacationManagement);
    return VacationManagement;
}(Mixins(LayoutMixin, SnackbarMixin)));
export default VacationManagement;
